import React from 'react';
import { MediaPlaceholder } from './MediaPlaceholder';
import { CtaButton } from './CtaButton';
import { ShieldCheck, Lock, CreditCard, Users, Zap } from 'lucide-react';
const badges = [{
  icon: ShieldCheck,
  label: 'Garantía 7 días'
}, {
  icon: Lock,
  label: 'Pago seguro'
}, {
  icon: CreditCard,
  label: 'Mercado Pago'
}, {
  icon: Users,
  label: '+3.597 Alumnas'
}, {
  icon: Zap,
  label: 'Acceso en 5 minutos'
}];
export function HeroSection() {
  return <section className="px-6 pt-6 pb-12 flex flex-col items-center text-center relative z-10 max-w-7xl mx-auto" data-id="element-156">
      {/* Students proof image (stars + avatars) */}

      {/* Hero Title */}
      <div className="w-full mb-10 max-w-5xl flex flex-col items-center" data-id="element-157">
        {/* Discount Badge */}
        <div className="text-brand-navy font-black text-[10px] md:text-sm px-8 py-2.5 rounded-full mb-8 shadow-[0_0_20px_rgba(217,139,175,0.4)] border border-white/60 uppercase tracking-widest bg-gradient-to-r from-brand-cream via-white to-brand-cream" data-id="element-158">
          <span className="bg-clip-text text-transparent bg-gradient-to-r from-[#D98BAF] to-brand-pinkDark" data-id="element-159">
            50% OFF - CUPOS LIMITADOS
          </span>
        </div>

        <h1 className="text-brand-navy font-black mb-6 tracking-tight uppercase text-[30px] md:text-[54px] md:leading-[1.1]" style={{
        fontFamily: "'Inter', sans-serif",
        fontWeight: 900
      }} data-id="element-160">
          APRENDÉ A CREAR{' '}
          <span className="text-[#D98BAF] underline decoration-[#D98BAF]/40 underline-offset-8" data-id="element-161">
            VIDEOS UGC
          </span>{' '}
          Y TRABAJA CON LAS MARCAS{' '}
          <span className="text-[#D98BAF] underline decoration-[#D98BAF]/40 underline-offset-8" data-id="element-162">
            DESDE CASA
          </span>
          💸
        </h1>

        <p className="text-lg md:text-2xl uppercase tracking-widest font-[700] font-[Montserrat,_sans-serif] text-brand-navy/80 mt-4" data-id="element-163">
          ✨ Sin experiencia ni seguidores. ✨ Desde cero, Con consultorías y
          acompañamiento 💻
        </p>
      </div>

      {/* Initial Video */}
      <div className="w-full mb-10 relative max-w-5xl" data-id="element-164">
        <div className="absolute -inset-1 bg-gradient-to-tr from-[#D98BAF] to-brand-lavender rounded-3xl blur-xl opacity-30" data-id="element-165"></div>
        <div className="relative w-full aspect-video rounded-3xl overflow-hidden shadow-[0_20px_50px_-12px_rgba(31,31,46,0.3)] bg-black z-10 border border-white/40" data-id="element-166">
          <iframe src="https://player.vimeo.com/video/1200659338?badge=0&amp;autopause=0&amp;player_id=0&amp;app_id=58479" frameBorder="0" allow="autoplay; fullscreen; picture-in-picture; clipboard-write; encrypted-media; web-share" className="absolute top-0 left-0 w-full h-full" title="formula_creadora_de_contenido_ugc_v3 (1080p)" data-id="element-167"></iframe>
        </div>
      </div>

      {/* Copy */}
      <p className="text-brand-navy font-medium md:text-3xl mb-8 px-4 max-w-4xl text-[17px] leading-relaxed" data-id="element-168">
        Con mi método paso a paso, dejá de improvisar y empezá a cobrar +$150
        usd por cada video UGC como una Creadora PRO💸✨
      </p>

      {/* Students count */}
      <div className="flex items-center gap-2 mb-8 bg-white/60 px-6 py-2 rounded-full border border-white shadow-sm" data-id="element-169">
        <span className="text-yellow-500 text-xl tracking-widest" data-id="element-170">★★★★★</span>
        <p className="text-brand-navy font-bold md:text-xl" data-id="element-171">
          +3.597 Alumnas UGC
        </p>
      </div>

      {/* CTA */}
      <div className="md:scale-110 md:my-4 w-full max-w-md" data-id="element-172">
        <CtaButton variant="gold" data-id="element-173">¡SI, QUIERO INSCRIBIRME!</CtaButton>
      </div>

      {/* Trust badges */}
      <div className="flex flex-wrap justify-center mt-8 px-6 py-4 bg-white/40 backdrop-blur-md rounded-2xl border border-white/60 shadow-sm max-w-4xl w-full" data-id="element-174">
        <span className="text-[11px] md:text-sm font-semibold text-brand-navy/70 text-center leading-relaxed tracking-wide" data-id="element-175">
          🛡️ Garantía 7 días &nbsp;•&nbsp; 🔒 Pago seguro &nbsp;•&nbsp; 💳
          Mercado Pago &nbsp;•&nbsp; ⭐ +3.597 Alumnas &nbsp;•&nbsp; ⚡ Acceso
          en 5 minutos
        </span>
      </div>
    </section>;
}